import { render, staticRenderFns } from "./60.vue?vue&type=template&id=94782bc0&"
import script from "./60.vue?vue&type=script&lang=js&"
export * from "./60.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCheckbox,VTextField})
